"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1849,5275],{

/***/ 74232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ EditableText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11293);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45823);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82522);





function EditableText(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? undefined : _maxLength, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style = _style === void 0 ? {} : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_TiptapTextEditor__WEBPACK_IMPORTED_MODULE_2__/* .TiptapTextEditor */ .C, {
        content: content,
        // onTextUpdate={({text}) => onChange('subHeading', text)}
        maxLength: maxLength,
        disabled: disabled,
        className: className,
        style: style,
        renderToolbarProps: function(editor) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tiptap_react__WEBPACK_IMPORTED_MODULE_4__/* .BubbleMenu */ .NM, {
                editor: editor,
                tippyOptions: {
                    duration: 100
                },
                shouldShow: function(props) {
                    return props.editor.isFocused;
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "floating-menu",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_components_TiptapTextEditor_ToolbarMenu__WEBPACK_IMPORTED_MODULE_3__/* .ToolbarMenu */ .H, {
                        editor: editor,
                        showFormattors: false
                    })
                })
            });
        }
    });
}


/***/ }),

/***/ 99849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ RichTextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(74151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/utils.tsx
var utils = __webpack_require__(5386);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/component/TextEditor.tsx
var TextEditor = __webpack_require__(74232);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/constant.ts
var constant = __webpack_require__(91074);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var Carousel_utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/btnUtils.js
var btnUtils = __webpack_require__(93080);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(98388);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CommonLinkWrapper/index.tsx
var CommonLinkWrapper = __webpack_require__(86353);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/component/TextWidgetSection.tsx
















function TextWidgetSection(param) {
    var data = param.data, widgetOptions = param.widgetOptions, currentIndex = param.currentIndex, widgetId = param.widgetId;
    var getSubtitleSize = function getSubtitleSize() {
        switch(textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitleSize){
            case buttonConstant/* BUTTON_SIZE_TYPE.SMALL */.n6.SMALL:
                return "!tw-text-[10px]";
            case buttonConstant/* BUTTON_SIZE_TYPE.MEDIUM */.n6.MEDIUM:
                return "!tw-text-[12px]";
            case buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE:
                return "!tw-text-[14px]";
            default:
                return "!tw-text-[10px]";
        }
    };
    var onNavigate = function onNavigate(e, index) {
        if (widgetId) {
            handleWidgetPropChange({
                subWidget: "TextGroup",
                subWidgetIndex: index,
                textGroupSection: activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.textGroupSection
            }, widgetId);
        }
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), widgetContextState = ref5.widgetContextState, handleWidgetPropChange = ref5.widgetContextHelpers.handleWidgetPropChange;
    var widgets = widgetContextState.widgets, activeWidgetId = widgetContextState.activeWidgetId;
    var activeWidget = widgets === null || widgets === void 0 ? void 0 : widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var sectionConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textSection;
    var baseConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.baseConfig;
    var isOverlap = baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP;
    var textGroupItem = data;
    var isSelected = (activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) === currentIndex && (activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.name) === "RichTextWithImage" && (0,lodash.isEqual)(activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.textGroupSection, widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textGroupSection);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            textAlign: constant/* TEXT_ALIGNMENT_POSITIONS */.MB === null || constant/* TEXT_ALIGNMENT_POSITIONS */.MB === void 0 ? void 0 : constant/* TEXT_ALIGNMENT_POSITIONS */.MB[isMobile ? sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.mobileAlignment : sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.alignment]
        },
        className: "tw-relative tw-z-[100] tw-flex tw-w-full tw-flex-col ".concat(isMobile ? "tw-justify-center tw-p-[20px]" : "tw-justify-".concat(sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.position, " tw-p-[60px]")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: function(e) {
                e.preventDefault();
                onNavigate(e, currentIndex);
            },
            style: {
                border: isSelected ? "1px solid #2B74D8" : ""
            },
            className: (0,bundle_mjs/* twMerge */.m6)("tw-relative tw-flex tw-flex-col ".concat(isMobile ? "tw-w-[90%]" : isOverlap ? "tw-w-[100%]" : "tw-w-[80%]", " tw-mx-auto"), (textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitlePosition) === "bottom" ? "tw-flex-col-reverse" : " tw-gap-[12px]"),
            children: [
                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-top-[-27.5px] tw-w-[108px] tw-bg-[#2F80ED] tw-px-[12px] tw-py-[4px] tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tw-text-[14px] tw-font-normal tw-text-[#fff]",
                        children: "Text group ".concat((activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.subWidgetIndex) + 1)
                    })
                }),
                (textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref = textGroupItem.subtitle) === null || ref === void 0 ? void 0 : ref.replace("<p></p>", "")) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
                    content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitle,
                    className: (0,bundle_mjs/* twMerge */.m6)("tw-font-normal tw-leading-[20px]", getSubtitleSize(), "".concat((textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.subtitlePosition) === "bottom" && ((ref1 = textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.button[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow) ? "tw-mt-[24px]" : ""))
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        (textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
                            content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.title,
                            className: "tw-font-normal tw-leading-[41px]"
                        }) : null,
                        (textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor/* EditableText */.s, {
                            content: textGroupItem === null || textGroupItem === void 0 ? void 0 : textGroupItem.description,
                            className: "tw-mt-[12px] tw-text-[16px] tw-font-normal tw-leading-[1.4]"
                        }) : null,
                        (textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref2 = textGroupItem.button) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-mt-[28px]",
                            children: (textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref3 = textGroupItem.button) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex tw-w-full",
                                style: {
                                    justifyContent: constant/* TEXT_ALIGNMENT_POSITIONS */.MB === null || constant/* TEXT_ALIGNMENT_POSITIONS */.MB === void 0 ? void 0 : constant/* TEXT_ALIGNMENT_POSITIONS */.MB[isMobile ? sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.mobileAlignment : sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.alignment]
                                },
                                children: textGroupItem === null || textGroupItem === void 0 ? void 0 : (ref4 = textGroupItem.button) === null || ref4 === void 0 ? void 0 : ref4.map(function(buttonData, btnIndex) {
                                    var ref, ref1;
                                    var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData);
                                    var selectedButtonType = buttonVariant[buttonData.type];
                                    var link = buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.actions) === null || ref === void 0 ? void 0 : ref.handler;
                                    var openInNewTab = buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.actions) === null || ref1 === void 0 ? void 0 : ref1.newTab;
                                    return buttonData.isShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonLinkWrapper/* default */.Z, {
                                        link: link,
                                        disableOnNewTab: openInNewTab,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            onClick: function(e) {
                                                (0,btnUtils/* btnActionHandler */.c)(buttonData === null || buttonData === void 0 ? void 0 : buttonData.actions, function() {});
                                            },
                                            size: buttonConstant/* BUTTON_SIZE_TYPE.LARGE */.n6.LARGE,
                                            btnType: buttonData.type,
                                            buttonData: buttonData,
                                            selectedButtonData: selectedButtonType,
                                            variant: selectedButtonType.variant,
                                            className: (0,bundle_mjs/* twMerge */.m6)("!tw-w-auto tw-rounded-[0px]  ".concat(buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL ? "!tw-px-[0px]" : "!tw-px-[36px]", " !tw-pb-[12px] !tw-pt-[12px] !tw-text-[14px] !tw-font-[500] !tw-leading-[20px] tw-text-newBlack")),
                                            children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                                        }, btnIndex)
                                    }) : null;
                                })
                            }) : null
                        })
                    ]
                })
            ]
        })
    });
}
function TextWidgetContainer(param) {
    var widgetOptions = param.widgetOptions, textContainerRef = param.textContainerRef, getImageHeight = param.getImageHeight, width = param.width, widgetId = param.widgetId;
    var getMobileOverlap = function getMobileOverlap() {
        var ref;
        var imageConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.imageSection;
        if ((imageConfig === null || imageConfig === void 0 ? void 0 : (ref = imageConfig.mobile) === null || ref === void 0 ? void 0 : ref.imageAlignment) === "top") {
            return "-40px";
        } else {
            return "40px";
        }
    };
    var getHeight = function getHeight(position) {
        var ref, ref1, ref2, ref3;
        var imageConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.imageSection;
        var numberOfTextWidget = widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.textGroupSection) === null || ref === void 0 ? void 0 : (ref1 = ref.groupItemsList) === null || ref1 === void 0 ? void 0 : ref1.length;
        var heightOfContent = textContainerRef === null || textContainerRef === void 0 ? void 0 : (ref2 = textContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.offsetHeight;
        var textContainerHeight = heightOfContent > 300 ? heightOfContent : 300;
        var imageHeight = numberOfTextWidget > 1 ? getImageHeight(imageConfig.desktop.height) : Number((ref3 = imageConfig.desktop.height) === null || ref3 === void 0 ? void 0 : ref3.replace("px", ""));
        if (textContainerHeight >= imageHeight) {
            return "40px";
        } else {
            var diff = imageHeight - textContainerHeight;
            switch(position){
                case "start":
                    {
                        return diff > 80 ? "40px" : "".concat(diff / 2, "px");
                    }
                case "center":
                    {
                        return "".concat(diff / 2, "px");
                    }
                case "end":
                    {
                        return diff > 80 ? "".concat(diff / 2 - 40 + diff / 2, "px") : "".concat(diff / 2, "px");
                    }
            }
        }
        return "";
    };
    var getTextContainerStyle = function getTextContainerStyle() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var sectionConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textSection;
        var baseConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.baseConfig;
        var selectedColorDetails = (0,utils/* getTextAndBackgroundColor */.Lv)(widgetOptions);
        var textColorAccToType = (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.textSection) === null || ref === void 0 ? void 0 : ref.bgFillType) === "image" ? widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref1 = widgetOptions.textSection) === null || ref1 === void 0 ? void 0 : ref1.textColor : selectedColorDetails === null || selectedColorDetails === void 0 ? void 0 : selectedColorDetails.text;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            width: isMobile && baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? "" : width,
            color: textColorAccToType,
            top: baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? isMobile ? getMobileOverlap() : getHeight(sectionConfig.position) : "",
            right: baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? isMobile ? "" : (imageSection === null || imageSection === void 0 ? void 0 : (ref2 = imageSection.desktop) === null || ref2 === void 0 ? void 0 : ref2.imageAlignment) === "left" ? "40px" : "-40px" : "",
            border: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.showBorder) && (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref3 = widgetOptions.baseConfig) === null || ref3 === void 0 ? void 0 : ref3.overlapType) === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? "1px solid #e2e4e7" : ""
        }, sectionConfig.bgFillType === "image" ? {
            backgroundImage: "url(".concat((sectionConfig === null || sectionConfig === void 0 ? void 0 : (ref4 = sectionConfig.bgImage) === null || ref4 === void 0 ? void 0 : ref4.url) || "", ")"),
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        } : {
            background: selectedColorDetails === null || selectedColorDetails === void 0 ? void 0 : selectedColorDetails.background
        }), {
            height: baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP && !isMobile ? "".concat(textContainerRef === null || textContainerRef === void 0 ? void 0 : (ref5 = textContainerRef.current) === null || ref5 === void 0 ? void 0 : ref5.offsetHeight, "px") : ""
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var imageSection = widgetOptions.imageSection, baseConfig = widgetOptions.baseConfig;
    var sectionConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.textSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: getTextContainerStyle(),
        className: "tw-relative tw-min-h-[300px] \n      ".concat(isMobile && baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? "tw-mx-auto tw-w-[90%]" : "tw-w-full", " \n       ").concat(isMobile ? "tw-justify-center" : "tw-flex tw-flex-col tw-justify-".concat(sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.position)),
        children: [
            (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.textSection) === null || ref === void 0 ? void 0 : (ref1 = ref.bgImage) === null || ref1 === void 0 ? void 0 : ref1.url) && (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref2 = widgetOptions.textSection) === null || ref2 === void 0 ? void 0 : ref2.bgFillType) === utils/* BASE_SECTION_BACKGROUND_TYPES.image */.xZ.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1] tw-bg-black",
                style: {
                    background: "rgba(0,0,0, ".concat(((widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref3 = widgetOptions.textSection) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.bgImage) === null || ref4 === void 0 ? void 0 : ref4.opacity) || 1) / 100 || 0.2, ")")
                }
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: textContainerRef,
                className: "tw-flex tw-w-[100%] tw-flex-col ".concat(isMobile ? "tw-py-[20px]" : ""),
                children: widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref5 = widgetOptions.textGroupSection) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.groupItemsList) === null || ref6 === void 0 ? void 0 : ref6.map(function(data, index) {
                    if (data.isVisible === false) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWidgetSection, {
                        currentIndex: index,
                        data: data,
                        widgetOptions: widgetOptions,
                        widgetId: widgetId
                    }, index);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(89429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/constants/builderConstants.ts
var builderConstants = __webpack_require__(79834);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/RichTextImage/index.tsx










var RichTextWithImageWidget = function(props) {
    var getOverlapPadding = function getOverlapPadding(currentPadding) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "bottom";
        if (type === "top") {
            if (currentPadding >= 40) return currentPadding;
            else return 40;
        } else if (type === "bottom") {
            if (currentPadding >= 80) return currentPadding;
            else return 80;
        }
    };
    var handleSectionClick = function handleSectionClick() {
        if (activeWidgetId) {
            handleWidgetPropChange({
                subWidget: "",
                subWidgetIndex: -1,
                textGroupSection: activeWidgetProps === null || activeWidgetProps === void 0 ? void 0 : activeWidgetProps.textGroupSection
            }, activeWidgetId);
        }
    };
    var getSectionContainerStyle = function getSectionContainerStyle() {
        var ref;
        var customClass = {
            position: "relative"
        };
        var imageSection = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.imageSection;
        if ((widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.baseConfig) === null || ref === void 0 ? void 0 : ref.overlapType) === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP) {
            if (isMobile) {
                var ref1;
                var isTop = (imageSection === null || imageSection === void 0 ? void 0 : (ref1 = imageSection.mobile) === null || ref1 === void 0 ? void 0 : ref1.imageAlignment) === "top";
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customClass), {
                    top: isTop ? "20px" : "-20px"
                });
            } else {
                var ref2;
                var isLeft = (imageSection === null || imageSection === void 0 ? void 0 : (ref2 = imageSection.desktop) === null || ref2 === void 0 ? void 0 : ref2.imageAlignment) === "left";
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customClass), {
                    marginLeft: isLeft ? "20px" : "-20px"
                });
            }
        }
    };
    var getImageHeight = function getImageHeight(imageHeight) {
        var ref;
        var maxContentHeight = textContainerRef === null || textContainerRef === void 0 ? void 0 : (ref = textContainerRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight;
        var imageActualHeight = Number(imageHeight === null || imageHeight === void 0 ? void 0 : imageHeight.replace("px", ""));
        var actualCalculatedHeight = maxContentHeight > imageActualHeight ? maxContentHeight : imageActualHeight;
        return actualCalculatedHeight;
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), widgetContextState = ref5.widgetContextState, handleWidgetPropChange = ref5.widgetContextHelpers.handleWidgetPropChange;
    var ref6 = (0,useGetDeviceType/* useGetDeviceType */.n)(), isMobileByServer = ref6.isMobile;
    var widgets = widgetContextState.widgets, activeWidgetId = widgetContextState.activeWidgetId, previewDevice = widgetContextState.previewDevice, isBuilder = widgetContextState.isBuilder;
    var isMobile = isBuilder ? previewDevice === "mobile" : isMobileByServer;
    var textContainerRef = (0,react.useRef)(null);
    var activeWidget = widgets[activeWidgetId];
    var activeWidgetProps = activeWidget === null || activeWidget === void 0 ? void 0 : activeWidget.props;
    var elementRef = (0,react.useRef)(null);
    var ref7 = (0,react.useState)(1), scale = ref7[0], setScale = ref7[1];
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(entries) {
            var entry = entries[0];
            if (entry.isIntersecting) {
                var visibleRatio = entry.intersectionRatio;
                setScale(1 + visibleRatio * 0.1);
            } else {
                setScale(1);
            }
        }, {
            root: null,
            threshold: Array.from({
                length: 11
            }, function(_, i) {
                return i * 0.1;
            })
        });
        if (elementRef.current) {
            observer.observe(elementRef.current);
        }
        return function() {
            if (elementRef.current) {
                observer.unobserve(elementRef.current);
            }
        };
    }, []);
    var widgetOptions = (0,_object_spread/* default */.Z)({}, utils/* RICH_IMAGE_TEXT_DEFAULT_WIDGET_OPTIONS */.pF, props.widgetOptions);
    var getWidthForTextContainer = function(dimensions) {
        var ref;
        var currentDimension = Number((ref = dimensions.width) === null || ref === void 0 ? void 0 : ref.replace("%", ""));
        return isMobile ? "100%" : 100 - currentDimension + "%";
    };
    var checkIfContentBigger = function() {
        var ref, ref1, ref2;
        var dimensions = (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.imageSection) === null || ref === void 0 ? void 0 : ref.desktop) || {};
        var maxContentHeight = textContainerRef === null || textContainerRef === void 0 ? void 0 : (ref1 = textContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight;
        var imageActualHeight = Number(dimensions === null || dimensions === void 0 ? void 0 : (ref2 = dimensions.height) === null || ref2 === void 0 ? void 0 : ref2.replace("px", ""));
        return imageActualHeight === 300 ? true : maxContentHeight > imageActualHeight;
    };
    var getCurrentClass = function(type) {
        switch(type){
            case "zoomIn":
                {
                    return "zoomInOnHover";
                }
            case "ambient":
                {
                    return "ambient";
                }
        }
    };
    var getStyleObject = function() {
        var baseConfig = widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.baseConfig;
        var paddingY = baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingY;
        var showOverlapPadding = baseConfig.overlapType === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP && checkIfContentBigger();
        var style = (0,_object_spread/* default */.Z)({
            paddingTop: showOverlapPadding ? getOverlapPadding(paddingY, "top") : paddingY,
            paddingBottom: showOverlapPadding ? getOverlapPadding(paddingY) : paddingY,
            paddingLeft: !isMobile ? baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingX : baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingMobileX,
            paddingRight: !isMobile ? baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingX : baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.paddingMobileX,
            marginTop: baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.marginTop,
            marginBottom: baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.marginBottom
        }, (baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.backgroundType) === utils/* BASE_SECTION_BACKGROUND_TYPES.color */.xZ.color ? {
            background: baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.background
        } : {
            backgroundImage: "url(".concat((baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.bgImage.url) || "", ")")
        });
        return style;
    };
    var renderImageSection = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        var dimensions = (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.imageSection) === null || ref === void 0 ? void 0 : ref.desktop) || {};
        var mobileDimension = (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref1 = widgetOptions.imageSection) === null || ref1 === void 0 ? void 0 : ref1.mobile) || {};
        var actualCalculatedHeight = getImageHeight(dimensions.height);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: handleSectionClick,
            style: {
                width: isMobile ? "100%" : dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
                height: isMobile ? mobileDimension.mobileHeight || 200 : actualCalculatedHeight + 4 + "px"
            },
            className: "imgWrapperGlobalStyle tw-overflow-hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: ((ref2 = widgetOptions.imageSection) === null || ref2 === void 0 ? void 0 : ref2.url) || builderConstants/* RICH_TEXT_IMAGE */.O8,
                style: {
                    width: "100%",
                    height: "100%",
                    transition: (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref3 = widgetOptions.imageSection) === null || ref3 === void 0 ? void 0 : ref3.animationType) === "onScroll" ? "transform 0.2s ease-out" : "",
                    transform: (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref4 = widgetOptions.imageSection) === null || ref4 === void 0 ? void 0 : ref4.animationType) === "onScroll" ? "scale(".concat(scale, ")") : "",
                    border: (widgetOptions === null || widgetOptions === void 0 ? void 0 : widgetOptions.showBorder) && (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref5 = widgetOptions.baseConfig) === null || ref5 === void 0 ? void 0 : ref5.overlapType) === utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? "1px solid #e2e4e7" : ""
                },
                className: "tw-object-cover \n        ".concat((ContentAnimationStyles_module_default())[getCurrentClass(widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref6 = widgetOptions.imageSection) === null || ref6 === void 0 ? void 0 : ref6.animationType)], "\n        ")
            })
        });
    };
    var renderSections = function() {
        var ref, ref1, ref2, ref3, ref4;
        var dimensions = (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.imageSection) === null || ref === void 0 ? void 0 : ref.desktop) || {};
        var widthForTextContainer = getWidthForTextContainer(dimensions);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: (0,_object_spread/* default */.Z)({
                border: (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref1 = widgetOptions.baseConfig) === null || ref1 === void 0 ? void 0 : ref1.showBorder) && (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref2 = widgetOptions.baseConfig) === null || ref2 === void 0 ? void 0 : ref2.overlapType) !== utils/* OVERLAP_TYPE.OVERLAP */.zQ.OVERLAP ? "1px solid #e2e4e7" : ""
            }, getSectionContainerStyle()),
            className: "tw-flex ".concat(isMobile ? "tw-flex-col" : "", " tw-items-stretch \n       ").concat((widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref3 = widgetOptions.imageSection) === null || ref3 === void 0 ? void 0 : ref3.desktop.imageAlignment) === "right" ? "tw-flex-row-reverse" : "", "\n       ").concat((widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref4 = widgetOptions.imageSection) === null || ref4 === void 0 ? void 0 : ref4.mobile.imageAlignment) === "bottom" && isMobile ? "tw-flex-col-reverse" : "", " \n       tw-w-[100%] tw-max-w-[1500px] "),
            children: [
                renderImageSection(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWidgetContainer, {
                    widgetOptions: widgetOptions,
                    textContainerRef: textContainerRef,
                    getImageHeight: getImageHeight,
                    width: widthForTextContainer,
                    widgetId: activeWidgetId
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: elementRef,
        style: getStyleObject(),
        children: [
            (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref = widgetOptions.baseConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.bgImage) === null || ref1 === void 0 ? void 0 : ref1.url) && (widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref2 = widgetOptions.baseConfig) === null || ref2 === void 0 ? void 0 : ref2.backgroundType) === utils/* BASE_SECTION_BACKGROUND_TYPES.image */.xZ.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1] tw-bg-black",
                style: {
                    background: "rgba(0,0,0, ".concat(((widgetOptions === null || widgetOptions === void 0 ? void 0 : (ref3 = widgetOptions.baseConfig) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.bgImage) === null || ref4 === void 0 ? void 0 : ref4.opacity) || 1) / 100 || 0.2, ")")
                }
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-relative tw-z-[10] tw-flex tw-justify-center",
                children: renderSections()
            })
        ]
    });
};
/* harmony default export */ var RichTextImage = (RichTextWithImageWidget);


/***/ })

}]);